module.exports={PASSPORT:"Passport",NATIONAL_ID_CARD:"Other id document"};